'use strict';

// FastAction NVTag plugin
define('FastAction',[
  'backbone',
  'hbs!template-fa-modal',
  'hbs!template-fa-confirm-account-modal',
  'fastaction_config',
  'fastActionUser',
  'FastActionView',
  'auth_popups',
  'profile_databag',
  'fast_databag',
  'currency',
  'cookieConsentConfiguration'
], function (Backbone, template_fa_modal, template_fa_confirm_account_modal, fastaction_config, user, FastActionView, auth_popups, profile_databag,
             fast_databag, currency, cookieConsentConfig) {
  var $ = Backbone.$,
    _ = Backbone._,
    user_view = null,
    fastActionEnabled = null,
    fastActionConnectionFailure = false,
    updateMyProfile = false,
    nologin = false,
    loggedIn = false,
    kiosk = false,
    gettingFastActionDatabag = null,
    fastActionHtml = '<i>Fast</i><b>Action</b>',
    FASTACTION_PROFILE_BLOCK_HTML = '<div class="fastaction-block"></div>',
    autoProcessPostData = null;

  function isNotEnabled() {
    return profile_databag.allowlisted === false
      || (!loggedIn && !(fastActionEnabled && !fastActionConnectionFailure));
  }

  function hasPayment(def) {
    return _(def).pluck('name').contains('PaymentInformation');
  }

  // cc block should be its own view
  function swap_credit_card_block(model) {
    if (isNotEnabled()) {
      return;
    }
    // This is kind of ugly, but it can fortunately go away when the fastAction plugin's
    // functionality is wholly subsumbed into NVTag proper.
    _.each(window.nvtag.tags, function (tag) {
      var formview = tag.formviews.current;
      if(formview.contactMode === 'org'){
        // do not fill CC in org mode
        return;
      }
      if (formview.model.get('fastAction')) {
        var paymentInfo = formview.subviews && formview.subviews.PaymentInformation;
        if (paymentInfo) {
          if (model.get('cc_4_digit') && model.get('cc_type')) {
            paymentInfo.changeReadonly(true, model.get('cc_4_digit'), model.get('cc_type'));
          } else {
            paymentInfo.changeReadonly(false);
          }
        }
      }
    });
  }

  function build_confirm_account_modal(currentFormView, fastBagDict, onConfirm) {

    // Build contact info
    var userName = '';
    if (fastBagDict.FirstName) {
      userName = fastBagDict.FirstName;
      if (fastBagDict.LastName) {
        userName += ' ' + fastBagDict.LastName[0];
        if (fastBagDict.LastName.length > 1) {
          userName += '.';
        }
      }
    }

    var userLocationDetails = [];
    if (fastBagDict.City) {
      userLocationDetails.push(fastBagDict.City);
    }

    if (fastBagDict.StateProvince) {
      userLocationDetails.push(fastBagDict.StateProvince);
    }

    var userLocation = '';
    if (userLocationDetails.length) {
      if (userName) {
        userLocation += ' \u2022 ';
      }
      userLocation += userLocationDetails.join(', ');
    }

    // Build card info
    var userCardDigits = '';
    if (fastBagDict.cc_4_digit) {
      if (fastBagDict.cc_type) {
        userCardDigits += ' \u2022 ';
      }
      userCardDigits += '****' + fastBagDict.cc_4_digit;
    }

    var resources = currentFormView.options.form_definition.resources;

    var currentFormVals = currentFormView.val();
    var faUrl = fastaction_config.urls.base();

    currentFormView.$el.find('#fastaction-confirm-account').remove();
    currentFormView.$el.append(template_fa_confirm_account_modal({
      text: {
        UserName: userName,
        UserLocation: userLocation,
        UserCardType: fastBagDict.cc_type,
        UserCardDigits: userCardDigits,
        YesCompleteDonation: resources.fill(resources.PrimaryResources.YesCompleteDonation, currency.format(currentFormVals.Amount))
      },
      ShowContactDetails: userName || userLocation,
      ShowCardDetails: fastBagDict.cc_type || userCardDigits,
      fastaction_url: faUrl,
      resources: resources
    }));
    $('a.fastaction-confirm-account-button').unbind()
      .click(onConfirm);
  }

  window.user = user;

  var renderFastActionView = function () {
    return user_view && user_view.render();
  };

  var setReadOnly = _.debounce(swap_credit_card_block, 50);

  var FastAction = (function () {
    // To handle auto-submit logic, we need to know when the form has rendered, when the fastaction databag is available,
    //  and when the fastaction profile is ready and logged in
    var deferredRender = $.Deferred();
    var deferredFastActionFill = $.Deferred();
    var deferredFastActionProfileReady = $.Deferred();
    var deferredFormdefSync = $.Deferred();
    var deferredFastActionCookies = $.Deferred();

    // FastAction will get attached to the first form on the page to trigger a sync event
    // Multiple forms on the same page are not handled gracefully, especially with autoprocessing links
    window.nvtag.once('sync:formdef', deferredFormdefSync.resolve);

    cookieConsentConfig.on('change:functionalAccepted', deferredFastActionCookies.resolve);

    if (cookieConsentConfig.areFunctionalCookiesAccepted()) {
      deferredFastActionCookies.resolve();
    }

    // Fetch fastaction information once the form definition has loaded and fastAction cookies
    // are either accepted or we are not in Cookie Consent Mode
    $.when(deferredFormdefSync, deferredFastActionCookies).done(function (formView) {
      var formModel = formView.model;
      if (formModel.get('fastAction')) {
        var metadata = formModel.get('metadata');
        var autoFastAction = formModel.get('autoFastAction');
        var qs = formView.options.query_string;

        // We'll attempt to autoprocess the form if a token is present, and its enabled on the form definition
        var attemptAutoProcess = autoFastAction && formView.isFirstForm() && qs.tknfa && formview.contactMode !== 'org';

        // If the form def has autoprocessing enabled, set it up to autoprocess
        // once all the necessary information has been loaded.
        if (attemptAutoProcess) {
          $.when(deferredRender, deferredFastActionProfileReady, deferredFastActionFill)
            .done(function () {
              processAutoSubmit(formView, qs.tknfa, qs);
            });
        }

        // When the form definition tells us to, log in to the specified fastaction profile
        // This is determined by per-contact information encoded in the query string
        if (metadata && metadata.fastActionLoginId) {
          var fastActionFormDefId = metadata.fastActionLoginId;

          var fastActionLogin = function fastactionLogin() {
            user.set('id', fastActionFormDefId);
            user.loginAndFetchProfile(fastActionFormDefId)
              .then(function () {
                deferredFastActionProfileReady.resolve();
              });
          };

          // When the supporter says this isn't them, we need to reload the page in a way that
          // (1) busts the cache in OA
          // (2) doesn't try to autoprocess
          // The simplest approach here is just to replace the 'tknfa' parameter with a 'notme' flag
          // Since IE11 doesn't have any URL helpers, use regex to do the replacment
          var fastActionNotMe = function fastActionNotMe() {
            deferredFastActionProfileReady.reject();
            user.logout();
            var re = /tknfa=[^&#]*/;
            var url = window.location.href;
            var newUrl = url.replace(re, 'notme=1');
            window.location = newUrl;
          };

          if (attemptAutoProcess) {
            // Wait for the databag profile to load, then show the confirmation modal
            // If confirmed, login as that fastaction profile; otherwise, clear out info as necessary
            // We load the databag directly to avoid setting any cross-domain cookies before confirmation occurs
            // If the databag is loaded but is missing cc info, we continue with the login
            fast_databag.set('id', fastActionFormDefId)
              .fetch({ cache: false });
            deferredFastActionFill.then(function () {
              var profileInfo = fast_databag.getDict();
              _.defer(function () {
                confirmFastActionUser(formView, profileInfo)
                  .then(fastActionLogin, fastActionNotMe);
              }, function () {
                fastActionLogin();
              });
            });
          } else {
            fastActionLogin();
          }
        } else {
          user.fetch()
            .then(function () {
              deferredFastActionProfileReady.resolve();
            });
        }
      }
    });

    // Submit the form, and make the autoprocessing data available to the alterPost method
    function processAutoSubmit(formView, token, qs) {
      formView.trigger('preAutoProcess');
      autoProcessPostData = {
        token: token,
        qs: qs
      };
      formView.focusOnNextRequiredValueOrSubmit({
        shouldRenderFeedback: true,
        submissionType: 'fastActionAutoSubmit'
      });
    }

    // Open the account confirmation modal, and return a promise that represents the users confirmation
    // Rejects the promise if the user does not confirm and closes the modal
    function confirmFastActionUser(formView, fastBagDict) {
      var deferredConfirmation = $.Deferred();
      var hasConfirmed = false;

      function onConfirm() {
        hasConfirmed = true;
        deferredConfirmation.resolve();
      }

      build_confirm_account_modal(formView, fastBagDict, onConfirm);
      window.location.hash = '#fastaction-confirm-account';

      // The next time the modal hide event is triggered, if the user didn't confirm, they must have rejected
      // We can't listen for a specific rejection because the modal library doesn't let you run a callback when the user hits 'ESC'
      $(document).one('cssmodal:hide', function () {
        if (!hasConfirmed) {
          deferredConfirmation.reject();
        }
      });

      return deferredConfirmation.promise();
    }

    fast_databag.on('change:cc_type', setReadOnly);
    fast_databag.on('change:cc_4_digit', setReadOnly);

    user.on('syncError', function () {
      fastActionConnectionFailure = true;
    });

    user.on('change:id', function (user, id) {
      if (id) {
        $('.at input[name="updateMyProfile"]').prop('checked', true);
        loggedIn = true;
        fastActionConnectionFailure = false;
        gettingFastActionDatabag = fast_databag.set('id', id).fetch({cache: false})
          .then(function(){}, fast_databag.deferred.reject);
      } else {
        loggedIn = false;

        _.each(window.nvtag.tags, function (tag) {
          var formview = tag.formviews.current;
          var resources = formview.options.form_definition.resources;
          formview.clear().fill();
          if (nologin) {
            formview.$('.updateMyProfileSection').show().find('.text').html(
              resources.fill(resources.PrimaryResources.RememberMeFastActionNextTime, fastActionHtml));
          } else {
            formview.$('.updateMyProfileSection').hide();
          }
          if (formview.multistep && formview.getStepIndex()) {
            formview.setStep(1);
          }
        });
      }
    });

    function FastAction() {
    }

    FastAction.prototype.alterFormDefinition = function (args) {
      nologin = !!args.form_definition.fastActionNologin;
      kiosk = !!args.query_string.kiosk;
      fastActionEnabled = !kiosk && !!args.form_definition.fastAction;
      var showUpdateMyProfile = !args.form_definition.hideUpdateMyFastActionProfile;

      // Only show the FastAction block if this form is FastAction enabled
      if (isNotEnabled()) {
        return args;
      }

      var fastActionBlock = {
        type: 'markup',
        // This should probably be updated to use the View's markup rather
        // than generating a new one. This breaks event binding.
        markup: FASTACTION_PROFILE_BLOCK_HTML,
        name: 'FastAction'
      };
      // Unshift to push this in as the first item
      args.form_definition.form_elements.unshift(fastActionBlock);

      var resources = args.form_definition.resources;

      if(showUpdateMyProfile) {
        var updateMyProfile = {
          type: 'markup',
          // This should probably be updated to use the View's markup rather
          // than generating a new one. This breaks event binding.
          /*jshint -W101 */
          markup: '<div class="updateMyProfileSection" style="display: none"><label style="display:inline;"><input type="checkbox" name="updateMyProfile" checked="checked"><span><span class="text">' + resources.fill(resources.PrimaryResources.UpdateMyFastActionProfile, fastActionHtml) + '</span></span></label></div>',
          /*jshint +W101 */
          name: 'UpdateMyProfile',
          contactMode: 'person'
        };
        var fieldsets = _(args.form_definition.form_elements).filter(function (def) {
          return def.hasOwnProperty('children');
        });
        var fieldset = null;
        if (args.form_definition.type === 'EventForm') {
          fieldset = fieldsets.first();
        } else {
          fieldset = fieldsets.find({name: 'PaymentInformation'}) || fieldsets.first();
        }
        if (fieldset) {
          fieldset.children.push(updateMyProfile);
        }
      }

      // See if user is logged in
      return args;
    };

    FastAction.prototype.alterErrors = function (args) {
      if (isNotEnabled()) {
        return args;
      }
      // If the user is logged in, we want to allow form submission without
      // the credit card triggering an error state.

      // We use cc_4_digit as a proxy to see if they have a card on file
      if (user.id && user.get('cc_4_digit')) {
        if (_.contains(['Account', 'ExpirationMonth', 'ExpirationYear'], args.field_name)) {
          args.errors = [];
        }
      }
      return args;
    };

    FastAction.prototype.postFill = function (args) {
      if (isNotEnabled()) {
        return args;
      }
      var formView = args.view,
        source = args.fill_source,
        dict = args.fill_dict;

      // If we have a populated fastaction fill dictionary with cc info, indicate that fastaction fill has ocurred
      // If we have a dictionary with no cc info but common contact fields, reject the promise
      // This event will trigger in some cases where the dictionary has populated keys that do not come from databag,
      // requiring this hack
      if (source === 'FastAction' && dict) {
        formView.clearFeedback();
        if (dict.cc_4_digit && dict.cc_type) {
          deferredFastActionFill.resolve();
        } else {
          deferredFastActionFill.reject();
        }
      }

      this.adjustCheckbox(formView);

      return args;
    };

    FastAction.prototype.adjustCheckbox = function (view) {
      var resources;
      if (view.options.form_definition &&
        view.options.form_definition.resources) {
          resources = view.options.form_definition.resources;
      } else if (view.options.formview &&
        view.options.formview.options.form_definition &&
        view.options.formview.options.form_definition.resources) {
          resources = view.options.formview.options.form_definition.resources;
      }
      if (!resources) {
        return;
      }

      var loginLabel = resources.fill(resources.PrimaryResources.UpdateMyFastActionProfile, fastActionHtml);
      if (nologin) {
        var label = view.$('.updateMyProfileSection').show().find('.text');
        if (loggedIn) {
          label.html(loginLabel);
        } else {
          label.html(resources.fill(resources.PrimaryResources.RememberMeFastActionNextTime, fastActionHtml));
        }
      } else {
        if (loggedIn) {
          view.$('.updateMyProfileSection').show().find('.text').html(loginLabel);
        } else {
          view.$('.updateMyProfileSection').hide();
        }
      }

      if (!cookieConsentConfig.areFunctionalCookiesAccepted()) {
        view.$('.updateMyProfileSection').hide();
      }
    };

    FastAction.prototype.postRender = function (args) {
      if (isNotEnabled()) {
        return args;
      }

      $(args.options.el).find('input[name="updateMyProfile"]').on('change', function(e){
        e.stopImmediatePropagation();
      });

      // TODO: Remove this args hack.  It should always exist; this is just a temporary work-around for a Drupal bug.
      if (args && args.thank) {
        $(args.options.el).prepend(FASTACTION_PROFILE_BLOCK_HTML);
      }
      // initialize once
      if (!user_view){
        user_view = new FastActionView({
          el: '.fastaction-block',
          model: user,
          nologin: nologin,
          resources: args.form_definition.resources || {}
        });
      }

      if (_.isEmpty(user.get('profiles')) && gettingFastActionDatabag) {
        gettingFastActionDatabag.always(renderFastActionView);
      }

      // Pass in template name, different templates Oberon and Accelerator!
      if (user.get('cc_4_digit')) {
        swap_credit_card_block(user);
      }

      fast_databag.promise().then(function (databag) {
        if (databag.get('cc_4_digit')) {
          // Hide cc block, show our fake one
          swap_credit_card_block(databag);
        }
      });

      deferredRender.resolve();
      return args;
    };

    FastAction.prototype.segue = function (args) {
      // Are any of the forms in the current chain fastAction forms?
      var fastAction = !kiosk && _.find(args.formviews, function (form) {
        return form.model.has('fastAction') && form.model.get('fastAction');
      });

      var form = args.formviews.current;
      var resources = form.options.form_definition.resources;

      if (fastAction) {
        var text = {
          AutofillQuickly: resources.fill(resources.PrimaryResources.AutofillQuickly, fastActionHtml),
          SingleClick: resources.fill(resources.PrimaryResources.SingleClick, '<br>')
        };

        var nologinSetting = args.thank && nologin && updateMyProfile;

        var faUrl = fastaction_config.urls.base();
        args.calling_tag.$el.find('.fastaction-modal').remove();

        args.calling_tag.$el.append(template_fa_modal({
          isSignup: true,
          nologin: nologinSetting,
          url: faUrl,
          prefix: 'signup',
          other: 'login',
          actionid: 'actionid_signup',
          text: _.extend({
            StoredOnThisDevice: resources.PrimaryResources.StoredOnThisDevice,
            SignUpForAnAccount: resources.fill(resources.PrimaryResources.SignupForAnAccount, fastActionHtml),
            ActionText: nologinSetting ? resources.PrimaryResources.SignUpNow : resources.PrimaryResources.SignUpWithYourEmail,
            OrBlankUsing: resources.fill(resources.PrimaryResources.OrBlankUsing,
              resources.PrimaryResources.SignUp.toLowerCase()),
            OtherOptionText: resources.fill(resources.PrimaryResources.AlreadyHaveFastAction, fastActionHtml),
            ByClickingAgree: resources.fill(resources.PrimaryResources.ByClickingAgree,
              resources.PrimaryResources.LogIn, fastActionHtml)
          }, text),
          resources: resources
        })).append(template_fa_modal({
          url: faUrl,
          prefix: 'login',
          other: 'signup',
          actionid: 'actionid',
          text: _.extend({
            ActionText: resources.PrimaryResources.LogInWithYourEmail,
            OrBlankUsing: resources.fill(resources.PrimaryResources.OrBlankUsing,
              resources.PrimaryResources.LogIn.toLowerCase()),
            OtherOptionText: resources.fill(resources.PrimaryResources.DontHaveFastAction, fastActionHtml),
            ByClickingAgree: resources.fill(resources.PrimaryResources.ByClickingAgree,
              resources.PrimaryResources.SignUp, fastActionHtml)
          }, text),
          resources: resources
        }));

        if (args.thank && nologin && !loggedIn && cookieConsentConfig.areFunctionalCookiesAccepted()) {
          fast_databag.fetch({cache: false});
        }
      }

      if (cookieConsentConfig.areFunctionalCookiesAccepted()) {
        auth_popups(user.get('fastActionSessionId'));
      }
      

      var hasAsked = user_view && user_view.asked;
      var shouldAsk = args.thank || !(form.isFirstForm() || hasPayment(form.model.get('form_elements')));

      if (fastAction && cookieConsentConfig.areFunctionalCookiesAccepted() && updateMyProfile && (!loggedIn || !user.get('authed')) && !hasAsked && shouldAsk) {
        // Fire up the hustle modal
        window.location.hash = 'fastaction-signup';
        user_view.asked = true;
        if (nologin && updateMyProfile) {
          user.fetch({cache: false});
        }
      }
    };

    FastAction.prototype.onSubmit = function (args) {
      var checkUpdateMyProfileInputs = args.currentTarget
        ? $(args.currentTarget).find('input[name="updateMyProfile"]:checked')
        : args.formview.$('input[name="updateMyProfile"]:checked');

      var isOrgMode = args.formview && args.formview.contactMode === 'org';
      updateMyProfile = !isOrgMode && checkUpdateMyProfileInputs.length > 0;
      return args;
    };

    FastAction.prototype.alterPost = function (args) {
      // Detect if we're past step one of a multistep advocacy form,
      // and treat it like a form without fastaction enabled - don't post on form submit.
      // You should also not alter the post if the form is in consent mode and the supporter has not consented.
      if (isNotEnabled() || args.form_definition.hideUpdateMyFastActionProfile ||
        !cookieConsentConfig.areFunctionalCookiesAccepted()) {
        return args;
      }

      if (updateMyProfile) {
        if (nologin && !loggedIn) {
          args.data.autoCreateAccount = 'true';
        } else if (loggedIn) {
          fast_databag.setWithFormState(args.data).save();
        }
      } else {
        args.data.ignorePaymentInfo = 'true';
      }

      if (user.get('id')) {
        args.data.fastActionId = user.get('id');
      }

      if (user.get('fastActionSessionId')) {
        args.data.fastActionSessionId = user.get('fastActionSessionId');
      }

      args.data.endpoint = args.endpoint;
      args.url = fastaction_config.urls.forms();

      // If autoprocess data exists, add it to the form submission
      if (autoProcessPostData) {
        args.data.autoProcessToken = autoProcessPostData.token;
        args.data.qs = JSON.stringify(autoProcessPostData.qs);
        autoProcessPostData = null;
      }

      return args;
    };

    FastAction.prototype.fast_action_databag = function () {
      return fast_databag;
    };
    FastAction.prototype.profile_databag = function () {
      return profile_databag;
    };
    FastAction.prototype.user = function () {
      return user;
    };

    return FastAction;
  })();

  return new FastAction();
});

